export function formatCurrencyGBP(pounds: number) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    currencyDisplay: 'narrowSymbol',
  }).format(pounds);
}
